import React from 'react';
import WatchReview from '../watchReview'


function BlueIguana(props) {

        return (
            <WatchReview 
                tube="https://www.youtube.com/embed/KS4GAUrfswU" 
                blerb="Welcome to Brothers Sip and Talk Shit, where we discuss all  things horror and foreign films. Over our next drink, we discuss English film, 'BLUE IGUANA'. Our worse rated film yet! Don't miss the post credits scene..."
            />
        )
    }  

export default BlueIguana;

